module.exports = __webpack_public_path__ + "img/flour.6bdab93d.webp";